export default {
  rendicionCtasMenu: "/Menu-RC.json",
  presupuestoEgresos: "/Presup-Egres/Presupuesto-de-Egresos.json",
  SRFTMpiosMenu: "/SRFT/Mpios/SRFT-Menu-Mpios.json",
  SRFTMpiosContenido: '/SRFT/Mpios/SRFTM',
  SRFTOPMenu: "/SRFT/OP/SRFT-Menu-OP.json",
  SRFTOPContenido: '/SRFT/OP/SRFTOP',

  SFUMpiosMenu: "/SFU/Mpios/SFU-Menu-Mpios.json",
  SFUMpiosContenido: '/SFU/Mpios/SFUM',
  SFUOPMenu: "/SFU/OP/SFU-Menu-OP.json",
  SFUOPContenido: '/SFU/OP/SFUOP',
  // *** finanzas publicas url***
  finanzasPublicasMenu: "/IFP/Informe-Finanzas-publicas.json",
  evolucionGastoPublico: "/IFP/Evol-Gto-Pub-Desagre.json",
  evolucionGastoPublicoGastos: "/IFP/Evol-Gto-Pub-Desagre.json",
  // procesoContratacionDeudaPublica: "/IFP/PCDP/Proc-Contratac-DP.json",
  procesoContratacionDeudaPublica: "/IFP/PCDP/Proc-Contratac-DP-Remasterizado.json",

  // *** Cuentas Publicas***
  cuentasPublicasInfoPrincipal: '/Cuentas-Pub/CP-Menu.json',
  cuentasPublicasInfoContenido: '/Cuentas-Pub/CP',
  cuentasPublicasInfoCOP: '/Cuentas-Pub/CP',
  cuentasPublicasRelacBienes: '/Cuentas-Pub/CP-RB-',
  cuentasEstadosPrepProgOP: '/Cuentas-Pub/CP-EPPOP-',

//// ***Informe de Avance de Gestión Financiera
  gestionFinancieraInfoPrincipal: '/IAGF/IAGF-Menu.json',
  gestionFinancieraInfoContenido: '/IAGF/IAGF',

// *** Recursos Municipios***
participacionesFederalesMunicipiosUno: '/Rec-Mpios/participacionesMunicipios.json',
participacionesFederalesMunicipiosDos: '/Rec-Mpios/participacionesMunicipios-2.json',
aportacionesFederalesMunicipios:'/Rec-Mpios/aportacionesFederalesMunicipios.json',
participacionesAportacionesMunicipios20012012:'/Rec-Mpios/participacionesAportacionesMunicipios2001-2012.json',
proyectosDesarrolloRegional: '/Rec-Mpios/proyectosDesarrolloRegional.json',
fortalece:'/Rec-Mpios/fondoParaElFortalecimientoInfraestructuraEstatalMpal.json',
fondoParaFronteras:'/Rec-Mpios/fondoParaFronteras.json',
fortaseg:'/Rec-Mpios/FORTASEG.json',

  // *** Armonizacion contable ***
  avanceChiapas: "/armonizacionContable/AvanceChiapas.json",
  resultadosEvaluacionesArmonizacionCont: "/armonizacionContable/ResultadoEvaluacionesArmonizacionCont.json",
  resultadosEvaluaciones: "/armonizacionContable/ResultadoEvaluaciones.json",
  documentosPublicadosChiapas: "/armonizacionContable/docPublicadosChiapas.json",
  documentosAprobadosConac: "/armonizacionContable/docAprobConac.json",
  informacionConsolidada: "/armonizacionContable/formatos-CONAC/informacionConsolidada.json",
  ProvisionesSalarialesEconomicas: "/armonizacionContable/formatos-CONAC/ProvisionesSalarialesEconomicas.json",
  ganismosSubsidiadosAC: "/armonizacionContable/formatos-CONAC/OS/OrganismosSubsidiadosAC.json",
  OrganismosSubsidiadosInforLeyDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/OS/OrganismosSubsidiadosInforLeyDisciplinaFinanciera.json",
  AyudaCiudadania: "/armonizacionContable/formatos-CONAC/AC/AyudaCiudadania.json",
  AyudaCiudadaniaDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/AC/AyudaCiudadaniaDisciplinaFinanciera.json",
  DeudaPublica: "/armonizacionContable/formatos-CONAC/DP/DeudaPublica.json",
  DeudaPublicaDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/DP/DeudaPublicaDisciplinaFinanciera.json",
  Obligaciones: "/armonizacionContable/formatos-CONAC/obligaciones/Obligaciones.json",
  ObligacionesDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/obligaciones/ObligacionesDisciplinaFinanciera.json",
  Municipios: "/armonizacionContable/formatos-CONAC/Mpios/Municipios.json",
  MunicipiosDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/Mpios/MunicipiosDisciplinaFinanciera.json",
//** Armonizacion contable=>formatosConac=>secretariaHacienda **//
SHArmonizacionCont: "/armonizacionContable/formatos-CONAC/SH/ArmonizacionCont-SH.json",
SHDisciplinaFinanciera: "/armonizacionContable/formatos-CONAC/SH/DisciplinaFinanciera-SH.json",
SHAnexo: "/armonizacionContable/formatos-CONAC/SH/Anexo-SH.json",
SHPatrimonio: "/armonizacionContable/formatos-CONAC/SH/IBPatrimonio.json",
MobiliarioEquipo: "/armonizacionContable/formatos-CONAC/SH/MobiliarioEquipo.json",
InventarioVehicular: "/armonizacionContable/formatos-CONAC/SH/InventarioVehicular.json",
CuentaPublicaFinanciera: "/armonizacionContable/formatos-CONAC/SH/CuentaPublicaFinanciera.json",
CuentaPublicaPresupuestal: "/armonizacionContable/formatos-CONAC/SH/CuentaPublicaPresupuestal.json",
InformacionContable: "/armonizacionContable/formatos-CONAC/SH/InformacionContable.json",
InformacionPresupuestal: "/armonizacionContable/formatos-CONAC/SH/InformacionPresupuestal.json",
InfoProgramatica: "/armonizacionContable/formatos-CONAC/SH/InfoProgramatica.json",







  /********Rendición de Cuentas -> Estrategico Institucional por Organismo Público*********** */
  // EIOPListAniosTomos: '/EIOP/EIOP-Menu-Anios-Tomos.json',
  EIOPListAniosTomos: '/EIOP/EIOP-Menu-Anios-Tomos-Remasterizado.json',
  EIOPInfo: '/EIOP/EIOP-',
  EIOPListAnio: "/EIOP/Menu-EIOP.json",
  EIOPListTomos: "/EIOP/Menu-EIOP-Tomos.json",


  EIOP2012: "/EIOP/EIOP-2012.json",
  EIOP2011TI: "/EIOP/EIOP-2011-TI.json",
  EIOP2011TII: "/EIOP/EIOP-2011-TII.json",
  EIOP2011TIII: "/EIOP/EIOP-2011-TIII.json",
  EIOP2011TIV: "/EIOP/EIOP-2011-TIV.json",
  EIOP2011TV: "/EIOP/EIOP-2011-TV.json",
  EIOP2010: "/EIOP/EIOP-2010.json",
  EIOP2009: "/EIOP/EIOP-2009.json",
  EIOP2008: "/EIOP/EIOP-2008.json",
  EIOP2007TI: "/EIOP/EIOP-2007-TI.json",
  EIOP2007TII: "/EIOP/EIOP-2007-TII.json",
  EIOP2006TI: "/EIOP/EIOP-2006-TI.json",
  EIOP2006TII: "/EIOP/EIOP-2006-TII.json",
  EIOP2005TI: "/EIOP/EIOP-2005-TI.json",
  EIOP2005TII: "/EIOP/EIOP-2005-TII.json",
  EIOP2004TI: "/EIOP/EIOP-2004-TI.json",
  EIOP2004TII: "/EIOP/EIOP-2004-TII.json",
  EIOP2003: "/EIOP/EIOP-2003.json",
  EIOP2002: "/EIOP/EIOP-2002.json",
  EIOP2003: "/EIOP/EIOP-2003.json",
  EIOP2001: "/EIOP/EIOP-2001.json",


  /********Rendición de Cuentas -> Informe de Finanza Publica*********** */
  informeFinanzasPubMenu: "/IFP/IFP-Menu.json",
  ////Evolución del gasto
  evolucionGastosHistorico: '/IFP/Evol-Gasto-Pub/Evol-Gto-Gastos.json',
  evolucionGastoClasifDesag: '/IFP/Evol-Gasto-Pub/Evol-Gto-Desagre.json',
  //Elementos Programáticos
  aniosyOpcElemenProg: '/IFP/Elementos-Prog/Elem-Prog-Menu.json',
  elemenProgDataporAnio: '/IFP/Elementos-Prog/Elem-Prog-',
  //Infomes Contables
  // opcionesInforCont: '/IFP/Informes-Contables/Informes-Contables-Menu.json',
  opcionesInforCont: '/IFP/Informes-Contables/Informes-Contables-Menu-Remasterizado.json',
  contenidoOpcInfoCont: '/IFP/Informes-Contables/',

  //Información Financiera de los Entes Públicos
  // opcionesIFEP: '/IFP/Informacion-Financ-EP/IFEP-Menu.json',
  opcionesIFEP: '/IFP/Informacion-Financ-EP/IFEP-Menu-Remasterizado.json',
  contenidoOpcIFEP: '/IFP/Informacion-Financ-EP/',






   /********Rendición de Cuentas -> Informe de Avance Trimestral - Cuenta Pública*********** */
  //  aniosTrimInfoAvancTrimCtaPub: '/IATCP/IATCP-Menu.json',
   aniosTrimInfoAvancTrimCtaPub: '/IATCP/IATCP-Menu-Remasterizado.json',
   contenidoTrimInfoAvancTrimCtaPub: '/IATCP/IATCP',

  /********Rendición de Cuentas -> Presupuesto de Egresos por Organismo Público*********** */
  presupuestoEgresosOP: '/Presup-egres-OP/Presup-egres-org-pub.json',

  // ****
  notificacionesPorEdictos:'/Notificaciones/notificacionesPorEdictos.json',
  notificacionesPorEstrados:'/Notificaciones/notificacionesPorEstrados.json',

// CONOCENOS
// comite de etica y de prevención de conflictos de interés
comiteEticaPrevencion:'/Conocenos/comiteDeEticayPrevencionDeConflictosIntereses.json',


avisoPrivacidad: '/Aviso-privacidad/AvisoPrivacidad.json',
carusel: '/caruselHome.json'












}
